/**
 * Formats a locale string to ensure proper casing
 * Language codes should be lowercase, country codes should be uppercase
 * @param locale - The locale string to format (e.g., 'es-mx', 'fr-ca', 'en')
 * @returns Properly formatted locale string (e.g., 'es-MX', 'fr-CA', 'en')
 */
export const formatLocale = (locale) => {
    if (!locale)
        return locale;
    // If locale contains a dash, format as language-COUNTRY
    if (locale.includes('-')) {
        const [language, country] = locale.split('-');
        return `${language.toLowerCase()}-${country.toUpperCase()}`;
    }
    // For simple language codes, just ensure lowercase
    return locale.toLowerCase();
};
